export const colors = {
  PRIMARY: '#0089C7',
  SECONDARY: '#0A2E4A',
  TERTIARY: '#517890',

  PRIMARY_HOVER: '#7191A3',
  PRIMARY_BORDER_HOVER: '#BBCDB8',
  PRIMARY_BG_HOVER: '#E5E7EB',
  COLOR_BORDER: '#D3D3D9',

  BG_COLOR: '#F3F4F6',

  COLOR_TEXT_DESCRIPTION: '#00000073',
  COLOR_TEXT: '#000000E0',
  COLOR_NAV: 'rgba(0, 0, 0, 0.45)',
  COLOR_TEXT_COMPONENTS: '#374151',
  NO_STATE_COLOR: '#cccccc',

  WHITE: '#FFFFFF',
  BLACK: '#000',
  RED: '#FF0000E0',
  TRANSPARENT: '#00000000',
  GREEN: '#00FF00',
  ORANGE: '#FFA500',
  LIGHTYELLOW: '#FFFFE0',

  ICON: '#2A77DB',
  BACKGROUND_ICON: '#E6EFFF',
};

export const cssVariables = `
  :root {
    --primary: ${colors.PRIMARY};
    --secondary: ${colors.SECONDARY};
    --tertiary: ${colors.TERTIARY};
    
    --primary-hover: ${colors.PRIMARY_HOVER};
    --primary-border-hover: ${colors.PRIMARY_BORDER_HOVER};
    --primary-bg-hover: ${colors.PRIMARY_BG_HOVER};
    --color-border: ${colors.COLOR_BORDER};
    
    --bg-color: ${colors.BG_COLOR};
    
    --icon: ${colors.ICON};
    --icon-bg: ${colors.BACKGROUND_ICON};
    
    --color-text-description: ${colors.COLOR_TEXT_DESCRIPTION};
    --color-text: ${colors.COLOR_TEXT};
    --color-nav: ${colors.COLOR_NAV};

    --color-white: ${colors.WHITE};
    --color-black: ${colors.BLACK};
    --color-red: ${colors.RED};
    --color-lightyellow: ${colors.LIGHTYELLOW};
  }
`;
